/**
 * Ryan O'Dowd
 * 2018-11-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({isDarkMode, colors}) => {
  return {
    linearGradient: (colorsToUse, linearGradientProps, opacity, darken) => {
      const colorsString = Platform.OS === 'web' ? colorsToUse.reverse().join(',') : colorsToUse.join(',');
      const backgroundColor = darken ? (isDarkMode ? colors.primary : colors.primary) : 'transparent';

      const styles: any = {
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: `linear-gradient(${linearGradientProps.angle ?? 0}deg, ${colorsString}), ${backgroundColor}`,
        backgroundBlendMode: 'darken',
        opacity,
      };

      if (Platform.OS !== 'web' && darken) {
        // @NOTE: this is because backgroundBlendMode doesn't work on native
        styles.backgroundColor = colors.black;
      }

      return styles;
    },
  };
};

export default getStyles;
